import React from 'react';

const FasterLoading: React.FC = () => {
  return (
    <section 
      className="faster-loading-section w-full px-6 md:px-12 lg:px-20 py-16 md:py-24"
      style={{ 
        background: 'linear-gradient(to bottom, #0a0a1a, #202130)' 
      }}
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        {/* Left Side - Laptop with Rocket */}
        <div className="relative">
          <div className="relative">
            {/* 2X FASTER Badge */}
            <div className="absolute -top-4 -left-4 z-10 bg-blue-500 text-white px-4 py-2 rounded-md font-bold text-sm shadow-lg">
              2X FASTER!
            </div>
            
            {/* Laptop Visual with Rocket */}
            <div className="relative">
              <img 
                src="/images/laptop2.png" 
                alt="Laptop with Rocket" 
                className="w-full h-auto object-contain drop-shadow-2xl"
              />
            </div>
          </div>
        </div>

        {/* Right Side - Content */}
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Load pages 2x faster.
          </h2>
          <div className="space-y-4 text-white/90 text-base">
            <p>Ads take surprisingly long to load.</p>
            <p>Blocking them makes pages load a lot faster (2x faster, in our experience).</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FasterLoading;

